<div class="card-novo-lg">
  <div class="flex flex-col md:flex-row gap-4 items-start p-6">

    <div class="w-full md:w-1/4 space-y-2">
      <div class="text-2xl font-bold text-rougeNovo mb-2">{{getLocalizedNom(parcours)}}@if (parcours.estRecurrent && parcours.recurrenceEnAnnees) {<span class="inline-block ml-2 px-2 py-0.5 text-xs font-normal leading-none rounded-full bg-gray-600 text-gray-100 whitespace-nowrap align-baseline">{{ 'LEARNING_PATH_MANAGEMENT.RECURRENCE_BADGE' | translate: { count: parcours.recurrenceEnAnnees } }}</span>}</div>
      <div class="mt-2">
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm font-medium">{{ 'SCORMS_LIST.PROGRESS' | translate }}</span>
          <span
          class="text-sm font-medium ">{{getCompletedCount()}}/{{getTotalCount()}}</span>
        </div>
        <div class="w-full rounded-full h-2 progress-bar-background">
          <div class="progress-bar-fill h-2 rounded-full transition-all duration-300"
          [style.width]="calculateProgress() + '%'"></div>
        </div>
      </div>
      <div class="mt-4">
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm font-medium">{{ 'SCORMS_LIST.DURATION_PROGRESS' | translate }}</span>
          <span class="text-sm font-medium">{{getCompletedDuration()}}/{{getTotalDuration()}}
          {{ 'SCORMS_LIST.MINUTES' | translate }}</span>
        </div>
        <div class="w-full rounded-full h-2 progress-bar-background">
          <div class="progress-bar-fill h-2 rounded-full transition-all duration-300"
          [style.width]="calculateDurationProgress() + '%'"></div>
        </div>
      </div>
    </div>

    <div class="w-full md:w-1/4 flex-shrink-0">
      <div class="text-lg font-semibold mb-3">{{ 'SCORMS_LIST.NEXT_ELEMENT' | translate }}</div>
      @if (getNextPackage(); as nextPackage) {
        <div
          class="justify-center rounded-3xl shadow-md cursor-pointer hover:shadow-lg hover:scale-105 transition-transform duration-300 ease-in-out">
          <a (click)="showDescriptionFn(nextPackage.scormPackage)" class="block no-underline m-0 p-0">
            <div class="flex-col p-0 bg-black rounded-3xl h-[220px] overflow-hidden">
              <div class="flex-grow flex h-[160px]">
                <img alt="img" class="w-full h-full object-cover rounded-t-3xl rounded-b-none"
                  [src]="getLocalizedContent(nextPackage.scormPackage.locales).thumbnail"
                  [alt]="getLocalizedContent(nextPackage.scormPackage.locales).titre + ' thumbnail'">
                </div>
                <div
                  class="w-full h-[66px] flex items-center justify-start px-3 footer-card bg-black transition-all duration-300 ease-in-out">
                  <span style="font-weight: 400; font-size: 1rem; margin-top: -10px;"
                    class="text-white text-left"
                  [innerHtml]="getLocalizedContent(nextPackage.scormPackage.locales).titre"></span>
                </div>
              </div>
            </a>
          </div>
        } @else {
          <div class="text-sm bg-green-50 text-green-700 p-4 rounded-xl text-center font-medium">
            {{ 'SCORMS_LIST.CONGRATULATIONS' | translate }}
          </div>
        }

      </div>

      <div class="w-full md:w-1/2">
        <div class="text-lg font-semibold mb-3">{{ 'SCORMS_LIST.ALL_ELEMENTS' | translate }}</div>
        <div class="space-y-4 max-h-56 overflow-y-auto pr-3 custom-scrollbar">
          @for (package of filteredPackages; track package) {
            <div class="w-full" [class.opacity-60]="package.estComplete">
              <a (click)="showDescriptionFn(package.scormPackage)" class="block card-hover">
                <div class="dark:bg-white dark:text-black rounded-xl overflow-hidden shadow-sm border border-gray-100 p-2 flex items-center gap-4"
                  [class.ring-2]="!package.estComplete && getNextPackage()?.scormPackage?.scormPackageId === package.scormPackage.scormPackageId"
                  [class.ring-rougeNovo]="!package.estComplete && getNextPackage()?.scormPackage?.scormPackageId === package.scormPackage.scormPackageId">
                  <div class="flex-grow">
                    <div class="text-base font-medium">
                    {{getLocalizedContent(package.scormPackage.locales).titre}}</div>
                  </div>
                  <div class="flex-shrink-0">
                    @if (package.estComplete) {
                      <span class="text-green-500 text-xl">✓</span>
                    } @else if (package.estARefaire) {
                      <span class="text-amber-500 text-xl"
                        [title]="'SCORMS_LIST.TO_REDO_TOOLTIP' | translate">↻</span>
                    } @else {
                      <span class="text-amber-500 text-xl">→</span>
                    }
                  </div>
                </div>
              </a>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
